/*global window, FB */

/**
 * View model constructor for Facebook login
 */
app.registerConstructor("FacebookLogin", function () {
    const self = this;
    this.trace = false;
    self.forceLogout = true;


    this.initFacebook = function (opts) {
        FB.init({
            appId: "" + opts.appId,
            channelUrl: opts.channel,
            status: true,
            xfbml: true,
            cookie: true
        });

        FB.Event.subscribe('auth.statusChange', function(response) {
          if(response.status == 'connected' && self.forceLogout === true) {
              self.forceLogout = false;
              setTimeout(function(){app.vm.FacebookLogin.fbLogout()},400);
          }
        });

    };

    this.fbLogout = function () {
        try{
              FB.logout();
        }
        catch(e){
          app.console.log("Fail to FB Logout on load"+ e );
        }
      };


    function getFBdetails() {
        FB.api("/me", {fields: "id,first_name,last_name,email,link,picture"},
            (response) => {
                if (response) {
                    const token =  FB.getAuthResponse().accessToken;
                    if (token) {
                        var imageURL;
                        if(response.picture && response.picture.data)
                        {
                            imageURL = response.picture.data.url;
                        }

                        app.vm.SocialLoginCommon.doRemoteLogin(token, response.id, response.first_name, response.last_name, response.email, "Facebook", response.link, response, imageURL);
                    } else {
                        app.console.error("Facebook login failed");
                    }
                } else {
                    app.console.error("An error occurred while fetching detail from Facebook");
                }
            });
    }

    /**
     * A callback listener to check the result of the user status and display login button if necessary
     * @param response Remote response from Facebook API
     * @param shouldPromptLogin Bring up login dialog if the user is not logged in
     */
    function checkLoginStatus(response, shouldPromptLogin) {

        if (response && response.status === "connected") {
            if (self.trace) app.console.log("User authorized " + response.status);
            getFBdetails();
        } else {
            if (self.trace) app.console.log("User is not authorised " + response.status);
            if (shouldPromptLogin) {
                if (self.trace) app.console.log("Prompt to login in");
                FB.login((res) => checkLoginStatus(res, false) , {scope: "email"});
            }
        }
    }

    /**
     * Bind the log in with facebook icon to the authentication API call
     */
    this.attachLoginButton = function (selector) {
        $(selector).click(function () {
            self.forceLogout = false;
            FB.getLoginStatus((res) => checkLoginStatus(res, true));
        });
    };

    /*============================== Log out ==============================*/
    this.logoutUser = function (logout_url) {
        // LogOut can't be called directly, so wrapping this in check login status.
        if (self.trace) app.console.log("Check status before logging out.");
        FB.getLoginStatus((response) => {
            if (response && response.status === "connected") {
                if (self.trace) app.console.log("User connected, try logout " + response.status);
                FB.logout(() => {
                    if (self.trace) app.console.log("Logged out of Facebook");
                    // Redirect to SB logout
                    location.replace(logout_url);
                });
            } else {
                if (self.trace) app.console.log("User is not connected " + response.status);
            }
        }, true);
    };
}).createVM();
